import React, { useState, useRef, useEffect } from 'react';
import NewsletterModal from './NewsletterModal';

export default function FinalCTA() {
  const [showModal, setShowModal] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  // Safely toggle modal visibility
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section
        ref={sectionRef}
        className="relative py-24 sm:py-32 md:py-40 bg-neutral-900 overflow-hidden"
        aria-labelledby="final-cta-heading"
      >
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/9e003815ddfdc849b418a18f0e86904c.jpg"
            alt="MeVER クリエイティブワークスペース"
            className="w-full h-full object-cover object-center opacity-20"
            loading="lazy"
            width="1920"
            height="1080"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/80 to-neutral-900/60" />
        </div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h2
            id="cta-heading"
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-10 sm:mb-16 tracking-tight"
          >
            Me Mode On.
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 flex-wrap">
            <a
              href="#products"
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-[#8E7AB5] text-white text-sm sm:text-base font-light tracking-wide hover:bg-[#7A6A9E] transition-colors whitespace-nowrap rounded-md cursor-pointer text-center"
              aria-label="製品セクションへスクロール"
            >
              製品を見る
            </a>
            <a
              href="https://appointment.mever.design/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center px-8 sm:px-10 py-3 sm:py-4 bg-white text-black text-sm sm:text-base font-medium tracking-wide hover:bg-white/90 transition-colors whitespace-nowrap rounded-md cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2" aria-hidden="true"></i>
              MeVER Chair 体験予約
            </a>
            <a
              href="#corporate"
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white text-sm sm:text-base font-light tracking-wide hover:bg-white/20 transition-colors whitespace-nowrap rounded-md border border-white/30 cursor-pointer text-center"
              aria-label="法人向けセクションへスクロール"
            >
              法人のお問い合わせ
            </a>
            <button
              onClick={openModal}
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white text-sm sm:text-base font-light tracking-wide hover:bg-white/20 transition-colors whitespace-nowrap rounded-md border border-white/30 cursor-pointer"
              aria-haspopup="dialog"
            >
              最新情報を受け取る
            </button>
          </div>
        </div>
      </section>

      {showModal && (
        <NewsletterModal
          title="MeVER 最新情報"
          description="新製品やキャンペーン情報をお届けします"
          formType="newsletter"
          onClose={closeModal}
        />
      )}
    </>
  );
}
